var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameKeyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2FFE9F97-BBB8-41AE-9008-D48FEF3BE227") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7BBFD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8CDFE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add-Requirement-Popup",
    transform: "translate(-997.000000, -356.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Popup",
    transform: "translate(208.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Game-Key",
    transform: "translate(772.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Game-Key-Icon",
    transform: "translate(40.154113, 39.563836) rotate(-315.000000) translate(-40.154113, -39.563836) translate(18.154113, 29.063836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36170213,3.83633388 C6.23739007,3.83633388 3.74468085,6.29418003 3.74468085,9.37479542 C3.74468085,12.4554108 6.23739007,14.913257 9.36170213,14.913257 C12.4860142,14.913257 14.9787234,12.4554108 14.9787234,9.37479542 C14.9787234,6.29418003 12.4860142,3.83633388 9.36170213,3.83633388 M9.36170213,0.144026187 C13.871234,0.144026187 17.6616312,3.32618003 18.5332057,7.52864157 L42.1276596,7.52864157 C43.1616596,7.52864157 44,8.35525696 44,9.37479542 L44,18.6055646 C44,19.6251031 43.1618156,20.4517185 42.1276596,20.4517185 C41.0936596,20.4517185 40.2553191,19.6251031 40.2553191,18.6055646 L40.2553191,11.2209493 L35.5744681,11.2209493 L35.5744681,16.7594108 C35.5744681,17.7789493 34.7362837,18.6055646 33.7021277,18.6055646 C32.6681277,18.6055646 31.8297872,17.7789493 31.8297872,16.7594108 L31.8297872,11.2209493 L18.5332057,11.2209493 C17.6616312,15.4234108 13.871234,18.6055646 9.36170213,18.6055646 C4.2135461,18.6055646 0,14.4509493 0,9.37479542 C0,4.29864157 4.2135461,0.144026187 9.36170213,0.144026187",
    id: "Fill-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameKeyIcon);
export default __webpack_public_path__ + "static/media/game-key-icon.a60539876614f6b0908b9fda5b14d8a3.svg";
export { ForwardRef as ReactComponent };